"use strict";
import flatpickr from "flatpickr";
import {Russian} from "flatpickr/dist/l10n/ru.js";
import Swiper, {Autoplay, Navigation, Pagination, Thumbs} from "swiper";
import {AnimateStyleBlocks} from "../animateStyleBlocks";
import {collapse} from "../collapse";
import {contactsMap} from "../contactsMap";
import customSelect from "../customSelect";
import {LiteFilter} from "../liteFilter";
import {productSlider} from "../productSlider";
import {sliders} from "../sliders";
import {userGeolocation} from "../userGeolocation";
import {suggestAddres} from "../suggestAddress";
import forms from "../forms/forms";
import {organizationFill} from "../organizationFill";
import addFavorite from "../addFavorite";
import {certificate} from "../certificate";
import {login} from "../login";
import {personal} from "../personal";
import {alert} from "../alert";
import {deliveryMap} from "../delivery-map";
import loyaltyProgressBar from "../loyalty-progress-bar";
import {onlyLatinLetters} from "../only-latin-letters";
import zipperModal from "../zipperModal";
import {feedbackTabs} from "../feedbackTabs";
import {simpleTimer} from "../simple-timer/simple-timer";
import {embroiderySelect} from "../embroidery-select";
import {changeGridLayout} from "../change-grid-layout";
import {filterBrands} from "../filter-brands";
import {menu} from "../menu";
import {StockForm} from "../stock-form";
import {PartnersMap} from "../partners-map";
import {stickyHeader} from "../sticky-header";
import {AboutVideo} from "../about-video";
import {captcha} from "../captcha";

flatpickr.localize(Russian);
// ПОДКЛЮЧЕНИЕ
Swiper.use([Navigation, Pagination, Autoplay, Thumbs]);

// MAP PIN

// НАСТРОЙКИ

captcha();

menu();

collapse({});

sliders(Swiper);

if (!window.matchMedia("(max-width: 1199px)").matches) {
  new AnimateStyleBlocks().init();
}

// Добавление datepicker
const fp = flatpickr(`.js-flatpicker`, {
  altInput: true,
  altFormat: "D j F Y",
  dateFormat: "Y-m-d",
  monthSelectorType: "static",
  defaultDate: new Date(),
  minDate: new Date(),
  static: true,
});
if (fp.length) {
  fp.config.onOpen.push(function (selectedDates, dateStr, instance) {
    const parent = instance.altInput.closest(`.personal-item__date-wrap`);
    const arrowIcon = parent.querySelector(`.personal-item__date-icon`);

    arrowIcon.classList.add(`personal-item__date-icon--active`);
  });
  fp.config.onClose.push(function (selectedDates, dateStr, instance) {
    const parent = instance.altInput.closest(`.personal-item__date-wrap`);
    const arrowIcon = parent.querySelector(`.personal-item__date-icon`);

    arrowIcon.classList.remove(`personal-item__date-icon--active`);
  });
}
// пткер времени для страницы сертификата
const fpCertificate = flatpickr(`.js-flatpicker-cert`, {
  altInput: true,
  enableTime: true,
  dateFormat: "Y-m-d H-i",
  altFormat: "D j F Y H:i",
  monthSelectorType: "static",
  minDate: new Date(),
  static: true,
  disableMobile: "true",
});

customSelect({activeItemClass: `select__item--active`, openClass: `select__list--active`});

productSlider();

contactsMap();

loyaltyProgressBar();

userGeolocation();

personal();

suggestAddres();

organizationFill();

forms({enabledAddFiles: false, isApplication: true, enabledAntispam: true});
forms({
  formSelector: `.js-form-contacts`,
  enabledAddFiles: false,
  isApplication: true,
  enabledCaptcha: true,
  formType: `contacts`,
});
forms({
  formSelector: `.js-form-partners`,
  enabledAddFiles: false,
  isPartnersForm: true,
  isApplication: true,
  enabledAntispam: true,
  enabledAddAdditionalInputs: true,
});
forms({formSelector: `.js-form-embroidery`, isApplication: true});
forms({formSelector: `.js-form-feedback`, enabledAddFiles: false, inputErrorClass: `input--error`});
forms({formSelector: `.js-form-cert`, enabledAddFiles: false, inputErrorClass: `input--error`, isCertificate: true});
// forms({
//   formSelector: `.js-form-stock`,
//   enabledAddFiles: false,
//   inputErrorClass: `input--error`,
//   isStockSubscribe: true,
//   confirmReset: true,
// });

addFavorite({activeClass: `add-favorite--pressed`});

certificate();

login();

alert();

deliveryMap();

onlyLatinLetters();

zipperModal();

feedbackTabs();

simpleTimer();

embroiderySelect();

const brandsFilter = new LiteFilter({
  containerSelector: `.js-brands-filter`,
  buttonSelector: `.js-brands-filter-btn`,
  itemToFilterSelector: `.js-brands-filter-item`,
  activeButtonClass: `tabs__tab--active`,
});
brandsFilter.init();

changeGridLayout();

filterBrands();

new StockForm();

new PartnersMap();

stickyHeader();

new AboutVideo();
